/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */


app.service('LogService', ["$rootScope", function ($rootScope) {


        var start = function ()
        {/*
            console.logg = console.log

            console.log = function (msg)
            {
                console.logg(msg)
                loggToHd(msg)
            }
            
            
            console.errorr = console.error

            console.error = function (msg)
            {
                console.errorr(msg)
                errorToHd(msg)
            }*/
        }
        
        var errorToHd = function (msg)
        {
            var logArray = localStorage.getItem("errorArray")
            if (logArray == undefined || logArray == "")
            {
                logArray = []
            }
            else
            {
                logArray = JSON.parse(logArray)
            }

            logArray.push(msg)
            logJson = JSON.stringify(logArray)
            localStorage.setItem("errorArray", logJson)
        }
        
        var loggToHd = function (msg)
        {
            var logArray = localStorage.getItem("logArray")
            /*if (logArray == undefined || logArray == "")
            {
                logArray = []
            }
            else
            {
                logArray = JSON.parse(logArray)
            }

            logArray.push(msg)
            logJson = JSON.stringify(logArray)
            localStorage.setItem("logArray", logJson)*/
        }

        return {
            start:start
        };

    }]);